import { CREATED_STATUSES } from "../constants";
import { SouvenirController } from "../souvenirController";
import SouvenirsList from "../souvenirsList";
import styles from "./styles.module.scss";

const SouvenirsBlock = ({
  souvenirs,
  souvenirsStatus,
  donationsStatus,
  getSouvenirs,
  cancelRequest,
  userEmail,
  error,
}: {
  souvenirs,
  souvenirsStatus,
  donationsStatus,
  getSouvenirs,
  cancelRequest,
  userEmail,
  error,
}) => {
  return (
    <section className={`${styles.Container} ${CREATED_STATUSES.includes(souvenirsStatus) && styles.ContainerAlt}`}>
      <div className="container">
        <div className={styles.SouvenirsBlock}>

          <div className={styles.SouvenirsBlock_info}>
            <h2>Кто и как может получить <span>значок и браслет</span></h2>
            <p>
              Чтобы получить значок или браслет, нужно подтвердить донации в вашем <a href="/profile">профиле</a>.
            </p>
            <ul>
              <li>Значок выдаётся за 20, 30, 75, 100 или 150 донаций. Для получения сувенира у вас должна быть хотя бы одна подтвержденная донация после регистрации в проекте и одна донация в 2025 году.</li>
              <li>Для браслета нужно сдать кровь или компоненты 3 раза в 2025 году.</li>
            </ul>
            <p>Сувениры доставляются бесплатно. Если у вас есть вопросы - напишите на <a href="mailto:support@donorsearch.org">support@donorsearch.org</a>.</p>
            <p>Для подтверждения принимаем:</p>
            <ul>
              <li>Справки формы 402, 405 или 448 из центра крови.</li>
              <li>Скриншот с Госуслуг с указанием ФИО, места сдачи крови, даты и типа донации.</li>
            </ul>
          </div>

          <SouvenirsList
            status={souvenirsStatus}
            souvenirs={souvenirs || {}}
          />
          <SouvenirController
            status={souvenirsStatus}
            donationsStatus={donationsStatus}
            souvenirs={souvenirs}
            getSouvenirs={getSouvenirs}
            cancelRequest={cancelRequest}
            userEmail={userEmail}
            error={error}
          />

        </div>
      </div>
    </section>
  );
};

export default SouvenirsBlock;
